import React, { useState } from 'react';
import RsvpModal from './RsvpModal';
import { submitRsvp } from '../lib/guestApi';
import './RsvpSection.css';

const RsvpSection = ({ endpoint, guest, onUpdated }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const { coming, guest_count, special_note } = guest || {};

  // Determine button state
  const getButtonState = () => {
    if (coming === true) {
      return { label: 'Potvrdeno', className: 'rsvp-section__btn--confirmed' };
    }
    if (coming === false) {
      return { label: 'Odbijeno', className: 'rsvp-section__btn--declined' };
    }
    return { label: 'Potvrdi dolazak', className: '' };
  };

  const buttonState = getButtonState();

  const handleOpenModal = () => {
    setError(null);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setError(null);
  };

  const handleConfirm = async (guestCount, note) => {
    setSaving(true);
    setError(null);

    try {
      await submitRsvp(endpoint, true, guestCount, note || null);
      setModalOpen(false);
      onUpdated?.();
    } catch (err) {
      console.error('Error submitting RSVP:', err);
      setError(err);
    } finally {
      setSaving(false);
    }
  };

  const handleDecline = async (note) => {
    setSaving(true);
    setError(null);

    try {
      await submitRsvp(endpoint, false, 0, note || null);
      setModalOpen(false);
      onUpdated?.();
    } catch (err) {
      console.error('Error submitting RSVP:', err);
      setError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <section id="rsvp" className="rsvp-section" aria-labelledby="rsvp-title">
      <div className="section-container rsvp-section__content">
        <h2 id="rsvp-title" className="rsvp-section__title">
          Potvrda dolaska
        </h2>

        <div className="rsvp-section__divider" aria-hidden="true" />

        <p className="rsvp-section__text">
          Molimo Vas da potvrdite svoj dolazak<br/> najkasnije do
          10. svibnja
          <br/>
          <br/>
          Ana 099 7891 180
          <br/>
          Josip 091 9122 577

        </p>

        <button
          type="button"
          className={`rsvp-section__btn ${buttonState.className}`}
          onClick={handleOpenModal}
        >
          {buttonState.label}
        </button>

        {/* Show summary if confirmed */}
        {coming === true && guest_count && (
          <div className="rsvp-section__summary">
            <p className="rsvp-section__summary-text">
              Broj gostiju: <strong>{guest_count}</strong>
            </p>
            {special_note && (
              <p className="rsvp-section__summary-note">
                "{special_note}"
              </p>
            )}
          </div>
        )}
      </div>

      <RsvpModal
        open={modalOpen}
        initialComing={coming}
        initialGuestCount={guest_count}
        initialNote={special_note}
        maxGuestCount={10}
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
        onDecline={handleDecline}
        saving={saving}
        error={error}
      />
    </section>
  );
};

export default RsvpSection;
